<template>
    <div class="navbar">
        <h1 class="logo">{{ name }}
            <IconMoodSmileDizzy :style="{ width: '28px', height: '28px', margin: '-6px auto' }" />
        </h1>

        <div class="buttons">
            <button v-if="chatId" @click="deleteChat">
                <IconTrash :style="{ width: '18px' }" />
            </button>
            <button class="menuOpen" @click="menuOpen">
                <IconMenu :style="{ width: '24px' }" />
            </button>
        </div>
    </div>
</template>

<script>
import { IconTrash, IconMoodSmileDizzy, IconMenu } from '@tabler/icons-vue';

export default {
    name: 'NavbarComponent',

    props: {
        chatId: {
            type: String,
            required: true
        },
    },

    components: {
        IconTrash,
        IconMoodSmileDizzy,
        IconMenu
    },

    data() {
        return {
            name: this.$projectName
        }
    },

    methods: {
        deleteChat() {
            this.$emit('deleteChat');
        },

        menuOpen() {
            this.$emit('menuOpen');
        }
    },
}
</script>

<style scoped>
.navbar {
    display: flex;
    justify-content: space-between;
    padding: 16px 22px;
    width: calc(100% - 431px);
    backdrop-filter: blur(4px);
    position: fixed;
    left: 431px;
    z-index: 9999;
    background-color: #0d1a1a69;
    /* border-bottom: 1px solid var(--color-border); */
}

button {
    font-size: 32px;
    width: 40px;
    height: 40px;
    padding: 0px;
}

select {
    padding: 8px 12px;
    border-radius: var(--default-border-radius);
    margin: 2px 2px 2px auto;
    margin-right: 10px;
    background-color: var(--color-hover);
    border: 1px solid var(--color-border);
    box-shadow: 0px 0px 10px #A3BFBA1F;
    color: var(--color-text);
    cursor: pointer;
    max-width: 120px;
}

h1 {
    font-size: 28px;
}

.menuOpen {
    display: none;
}

@media only screen and (max-width: 810px) {
    .navbar {
        width: 100%;
        left: 0;
        padding: 16px 22px;
    }

    .menuOpen {
        display: inline;
        margin-left: 10px;
    }

    select {
        margin-left: 2px;
    }
}
</style>